import React from 'react';
import {Stack, Typography} from '@mui/material';
import withMainContainer from '../../components/WithMainContainer.js';
import {withTitle} from '../../title.js';
import {Payform} from './TarotmailPayform.js';

const TarotmailPurchase = ()=>{
    return <Stack direction="column" alignItems="center" gap={2}>
      <Typography variant="h4">
        חידוש מנוי - אפליקציית המסרים
      </Typography>
      <Payform noTrialOrder/>
    </Stack>;
};

export default withTitle('אפליקציית המסרים',
    withMainContainer(TarotmailPurchase, {footerMargin: 4}));
